import "../infiniteslidev2.min.js";
const mediaSlider = async function( $block ) {
	const $slider = $block.find( ".media-slider" );

	if ( !$slider.length ) { return false; }

	$( $slider ).infiniteslide();
};
 
themeUtils.loadBlock( mediaSlider, "media", ".media" );